import { call, put } from 'redux-saga/effects';

import fetchUiConfigs from './services/fetchUiConfigs';
import * as actions from '../state';

// eslint-disable-next-line import/prefer-default-export
export function* userUiConfigs(decodedToken) {
  const uiConfigs = yield call(fetchUiConfigs, {
    domain: decodedToken ? decodedToken.domain : '*',
    user: decodedToken ? decodedToken.user : '*',
    role: decodedToken ? decodedToken.user_scope : '*',
    hostname: decodedToken ? decodedToken.iss : '*',
    reseller: decodedToken ? decodedToken.territory : '*',
  });

  yield put(actions.setConfig(uiConfigs));
}
